import { CartItem, QuantityInfo } from "../types";

export const getModifierGroupQtyDescription = (
  isRequired: boolean,
  qtyInfo: QuantityInfo
): string => {
  if (isRequired) {
    if (qtyInfo.minPermitted === qtyInfo.maxPermitted) {
      return `Choisissez ${qtyInfo.minPermitted}`;
    } else {
      return `Choisissez de ${qtyInfo.minPermitted} à ${qtyInfo.maxPermitted}`;
    }
  } else {
    return `Choisissez jusqu'à ${qtyInfo.maxPermitted}`;
  }
};

export const formatPrice = (priceInCents: number): string => {
  return `${(priceInCents / 100).toFixed(2)} €`;
};

export const cleanCartItems = (cartItems: CartItem[]): CartItem[] => {
  return cartItems.map((item) => ({
    ...item,
    modifierGroups: item.modifierGroups.filter(
      (group) => group.modifierOptions.length > 0
    ),
  }));
};
